<template>
  <div class="home">
    <v-snackbar
            v-model="messageBox.show"
            :timeout="messageBox.closeTimeout"
            light
            class="coa_snack"
            :class="'coa_' + messageBox.type"
    >
      {{ messageBox.content }}
      <template v-slot:action="{ attrs }">
        <v-btn
                text
                v-show="messageBox.closeTimeout === 0"
                v-bind="attrs"
                @click="messageBox.show = false"
        >
          {{messageBox.closeButtonText}}
        </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
import {popupShowTime} from "../plugins/constants";

export default {
  name: 'NotImplemented',
  created() {
    this.loadInitialData();
    this.$emit('updateHeaderNavigation', [{
      display: 'not implemented'
    }]);
  },
  data: () => ({
    messageBox: {
      show:            false,
      content:         '',
      closeButtonText: 'ok',
      closeTimeout:    -1,
    },
  }),
  methods: {
    loadInitialData: function() {
      this.showMessage('This Feature is not implemented yet.', 'error', popupShowTime);
    },
    showMessage(content, type, close, buttonText) {
      this.messageBox.content = content;
      this.messageBox.type = type;
      this.messageBox.show = true;
      if (typeof close === 'number') {
        this.messageBox.closeTimeout = close;
      } else {
        this.messageBox.closeTimeout = -1;
      }
      if (buttonText) {
        this.messageBox.closeButtonText = buttonText;
      } else {
        this.messageBox.closeButtonText = 'ok';
      }
    }
  }
}
</script>
